import React from 'react';
import { Helmet } from 'react-helmet';

const Blog = () => {
  const blogData = [
    {
        title: "Mumbai Cab Service",
        description: "Discover affordable and comfortable cab services in Mumbai with AB Ghule Cabs, offering convenient travel options for both local and sightseeing trips.",
        image: "/images/keyword/1.jpg",
        link: "Mumbai-Cab-Service"
    },
    {
        title: "Mumbai to Pune Cab",
        description: "Enjoy a smooth, hassle-free ride with AB Ghule Cabs on your journey from Mumbai to Pune. Our fleet ensures a comfortable and timely travel experience.",
        image: "/images/keyword/5.jpg",
        link: "Mumbai-to-Pune-Cab"
    },
    {
        title: "Mumbai to Goa Taxi",
        description: "Book your reliable taxi ride from Mumbai to Goa with AB Ghule Cabs. Our comfortable vehicles and experienced drivers will make your trip to Goa stress-free and enjoyable.",
        image: "/images/keyword/6.jpg",
        link: "Mumbai-to-Goa-Taxi"
    },
    {
        title: "Mumbai Airport Cab",
        description: "Ensure a smooth airport experience with AB Ghule Cabs' airport pickup and drop services. Our taxis offer comfort and timely travel, whether you're arriving or departing from Mumbai Airport.",
        image: "/images/keyword/7.jpg",
        link: "Mumbai-Airport-Cab"
    },
    {
        title: "Mumbai to Mahabaleshwar Cab",
        description: "Travel in comfort and style with AB Ghule Cabs on your journey from Mumbai to Mahabaleshwar. Our cab services provide a relaxing experience as you visit the beautiful hill station.",
        image: "/images/keyword/9.jpg",
        link: "Mumbai-to-Mahabaleshwar-Cab"
    },
    {
        title: "Pune Cab Service",
        description: "Explore Pune with AB Ghule Cabs' reliable local cab services. Whether you need a taxi for a short trip or an extended tour, we ensure a comfortable and affordable ride.",
        image: "/images/keyword/11.jpg",
        link: "Pune-Cab-Service"
    },
    {
        title: "Best Cab Service in Pune",
        description: "AB Ghule Cabs offers the best cab service in Pune, ensuring prompt and efficient travel. Whether it's a quick city ride or a day trip, we provide exceptional service at affordable prices.",
        image: "/images/keyword/14.jpg",
        link: "Best-Cab-Service-in-Pune"
    },
    {
        title: "Pune to Mumbai Cabs",
        description: "Choose AB Ghule Cabs for your Pune to Mumbai trip. Our cabs are well-maintained and driven by experienced chauffeurs to ensure a safe, comfortable, and timely journey.",
        image: "/images/keyword/15.jpg",
        link: "Pune-to-Mumbai-Cabs"
    },
    {
        title: "Pune to Lonavala Cabs",
        description: "Enjoy a scenic ride from Pune to Lonavala with AB Ghule Cabs. We offer a range of comfortable and affordable travel options, making your journey to Lonavala stress-free and relaxing.",
        image: "/images/keyword/18.jpg",
        link: "Pune-to-Lonavala-Cabs"
    }
];

    
      
    return (
        <div>
           
           <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable</title>
  <meta name="description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
  <meta name="keywords" content="Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, AB Ghule Cabs, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable" />
  <meta property="og:description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-mumbai-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />
  
  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Mumbai Cabs",
        description: "Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
        "priceRange": "₹1500 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "1500"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sneha Kulkarni"
            },
            "datePublished": "2024-12-22",
            "reviewBody": "Seamless booking process and the ride was very comfortable. Highly recommend AB Ghule Cabs for Pune to Mumbai trips."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vishal Sharma"
            },
            "datePublished": "2024-12-18",
            "reviewBody": "Great service at an affordable price. The driver was professional and punctual."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune and Mumbai",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-mumbai-cabs"
        },
        "keywords": "Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, AB Ghule Cabs, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way"
      }
    `}
  </script>
</Helmet>
            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className="text-white">Blog</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="row g-4 justify-content-center container">
                    {blogData.map((blog, index) => (
                        <div className="col-xl-4 col-lg-6 col-md-6" key={index}>
                            <div className="news-card-items mt-0">
                                <div className="news-image">
                                    <img src={blog.image} alt={blog.title} />
                                </div>
                                <div className="news-content">
                                    <div className="news-cont">
                                        <h3>
                                            <a href={blog.link} style={{ color: '#FF4101' }}>
                                                {blog.title}
                                            </a>
                                        </h3>
                                        <p>{blog.description}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default Blog;
